// Signup.js
import React, { useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

const Signup = () => {
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    name: '',
    email: '',
    courseName: '',
    courseCode: '',
    semester: 1,
    profilePic: '',
    password: '',
    confirmPassword: '',
  });

  const [emailAlreadyRegistered, setEmailAlreadyRegistered] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });

    // Reset the email already registered status when email changes
    if (name === 'email') {
      setEmailAlreadyRegistered(false);
    }
  };

  const handlelogin = () => {
    navigate('/login');
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setUserData({ ...userData, profilePic: reader.result });
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if password and confirm password match
    if (userData.password !== userData.confirmPassword) {
      console.error('Password and Confirm Password do not match');
      toast.error('Password and Confirm Password should be the same!');
      return;
    }

    try {
      // Make a POST request to the API
      const response = await axios.post('https://pgdost.onrender.com/api/users', userData);
      console.log('User created:', response.data);
      toast.success('Welcome To PGDost !!');

      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error.includes('email')) {
        // If the error message contains 'email', it means the email is already registered
        setEmailAlreadyRegistered(true);
        toast.error('Email is already registered. Please Login to your Account.');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        console.error('Error creating user:', error.response.data.error);
      }
    }
  };

  return (
    <div className="flex justify-center items-center h-full bg-gray-100">
      <form className="bg-white p-8 rounded shadow-md w-full max-w-md mt-8 rounded-lg" onSubmit={handleSubmit}>
        <h2 className="text-3xl font-bold mb-6 text-center">Sign Up</h2>

        <div className="mb-4">
          <label htmlFor="name" className="block text-gray-700 font-bold mb-2">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={userData.name}
            onChange={handleChange}
            className="w-full p-3 border rounded"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="email" className="block text-gray-700 font-bold mb-2">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={userData.email}
            onChange={handleChange}
            className="w-full p-3 border rounded"
            required
          />
        </div>

        <div className="mb-4 grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="courseName" className="block text-gray-700 font-bold mb-2">Course Name</label>
            <input
              type="text"
              id="courseName"
              name="courseName"
              value={userData.courseName}
              onChange={handleChange}
              className="w-full p-3 border rounded"
              required
            />
          </div>
          <div>
            <label htmlFor="courseCode" className="block text-gray-700 font-bold mb-2">Course Code</label>
            <input
              type="text"
              id="courseCode"
              name="courseCode"
              value={userData.courseCode}
              onChange={handleChange}
              className="w-full p-3 border rounded"
              required
            />
          </div>
        </div>

        <div className="mb-4">
          <label htmlFor="semester" className="block text-gray-700 font-bold mb-2">Semester</label>
          <input
            type="number"
            id="semester"
            name="semester"
            value={userData.semester}
            onChange={handleChange}
            className="w-full p-3 border rounded"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="profilePic" className="block text-gray-700 font-bold mb-2">Profile Image</label>
          <input
            type="file"
            id="profilePic"
            name="profilePic"
            onChange={handleFileChange}
            className="w-full p-3 border rounded"
          />
        </div>
        {userData.profilePic && (
          <img
            src={userData.profilePic}
            alt="Profile Preview"
            className="w-full h-auto rounded mb-4"
          />
        )}

        <div className="mb-4">
          <label htmlFor="password" className="block text-gray-700 font-bold mb-2">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={userData.password}
            onChange={handleChange}
            className="w-full p-3 border rounded"
            required
          />
        </div>

        <div className="mb-6">
          <label htmlFor="confirmPassword" className="block text-gray-700 font-bold mb-2">Confirm Password</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={userData.confirmPassword}
            onChange={handleChange}
            className="w-full p-3 border rounded"
            required
          />
        </div>

        <div className="mb-6">
          <button
            type="submit"
            className="w-full bg-blue-500 text-white p-3 rounded hover:bg-blue-700"
          >
            Sign Up
          </button>
        </div>

        <p className="text-center text-sm">
          <a className="text-blue-500 cursor-pointer" onClick={handlelogin}>
            Already have an Account? Login Now!
          </a>
        </p>
      </form>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

export default Signup;
